import React from "react"
import GetItOnAndroid from "../../assets/icons/getItOnAndroid.png"
import DownloadFromIos from "../../assets/icons/downloadOnIos.png"
import  "./style.scss"
function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}


export const IosAndroidBtn = ()=> {

   const platform = getMobileOperatingSystem();


   if(platform==="iOS"){
      return (
        <div className={"downloadOnIos"}>
          <img src={DownloadFromIos} alt="" onClick={()=>{
            setTimeout(function () { window.location = "https://apps.apple.com/ge/app/bassiani/id6449970743"; }, 25);
            window.location = "bassiani://";
          }}/>
        </div>
      )
   }else if(platform==="Android"){
     return (
       <div className={"getItOnAndroid"}>
         <img src={GetItOnAndroid} alt="" onClick={()=>{
           setTimeout(function () { window.location = "https://play.google.com/store/apps/details?id=com.bassiani.application"; }, 50);
           window.location.href = "bassiani://";
         }}/>
       </div>
     )

   }else{
      return (
        <div className={"downloadBothPlatform"}>
         <img src={DownloadFromIos} alt="" onClick={()=>{
           setTimeout(function () { window.location = "https://apps.apple.com/ge/app/bassiani/id6449970743"; }, 25);
           window.location = "bassiani://";
         }}/>

         <img src={GetItOnAndroid} alt="" onClick={()=>{
           setTimeout(function () { window.location = "https://play.google.com/store/apps/details?id=com.bassiani.application"; }, 50);
           window.location.href = "bassiani://";
         }}/>
        </div>
      )
   }
}
